import React from 'react'
import Form from 'react-bootstrap/Form'

const Radio = ({ checked, text, onChange, classNameParent, ...props }) => {
  const handleChangeChecked = e => {
    onChange(e)
  }

  return <div className={classNameParent}>
    <Form.Check
      {...props}
      type="radio"
      custom
      label={text}
      onChange={handleChangeChecked}
      checked={checked}
    />
  </div>
}
Radio.defaultProps = {
  disabled: false,
  classNameParent: 'col-12',
  onChange: () => {},
  required: false,
  text: ''
}

export default Radio